import { useState } from "react";
import axios from "axios";
import { Link, useNavigate, useSearchParams } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (pw.length < 6) { setErr("Password must be at least 6 characters."); return; }
    if (pw !== pw2) { setErr("Passwords do not match."); return; }
    setLoading(true);
    try {
      await axios.post(`${API}/auth/reset-password`, { token, password: pw });
      setDone(true);
      setTimeout(() => navigate("/login"), 2000);
    } catch (e) {
      setErr(e.response?.data?.detail || "Could not reset password. The link may have expired.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F8F9FA] flex items-center justify-center px-6">
      <div className="w-full max-w-md bg-white border border-slate-200 rounded-2xl shadow-sm p-8" data-testid="reset-password-page">
        <h1 className="font-display text-2xl font-bold text-[#0B2447]">Set a new password</h1>
        {!token ? (
          <p className="mt-4 text-red-600">This reset link is invalid. Please request a new one from the login page.</p>
        ) : done ? (
          <p className="mt-4 text-emerald-600" data-testid="reset-done">Password updated! Redirecting you to log in...</p>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <input type="password" required value={pw} onChange={(e) => setPw(e.target.value)} placeholder="New password"
              data-testid="reset-pw" className="w-full border border-slate-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-[#0B2447]/30" />
            <input type="password" required value={pw2} onChange={(e) => setPw2(e.target.value)} placeholder="Confirm new password"
              data-testid="reset-pw2" className="w-full border border-slate-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-[#0B2447]/30" />
            {err && <p className="text-sm text-red-600" data-testid="reset-error">{err}</p>}
            <button type="submit" disabled={loading} data-testid="reset-submit"
              className="w-full bg-[#0B2447] hover:bg-[#153461] text-white rounded-lg py-3 font-semibold disabled:opacity-50 transition-colors">
              {loading ? "Saving..." : "Update password"}
            </button>
          </form>
        )}
        <p className="mt-6 text-sm text-slate-500"><Link to="/login" className="text-[#0B2447] font-semibold underline">Back to log in</Link></p>
      </div>
    </div>
  );
}
